import * as sentry from '@sentry/angular-ivy';
import * as CookieConsent from 'vanilla-cookieconsent';

import { environment } from '../environments/environment';

export async function initCookieConsent(): Promise<void> {
	if (!environment.enableCookieConsent) {
		return;
	}

	try {
		await CookieConsent.run({
			guiOptions: {
				consentModal: {
					layout: 'bar inline',
					position: 'bottom',
				},
				preferencesModal: {
					layout: 'box',
				},
			},

			categories: {
				necessary: {
					enabled: true,
					readOnly: true,
				},
			},

			language: {
				default: 'da',
				translations: {
					da: {
						consentModal: {
							title: 'Vi bruger cookies',
							description:
								'Vi bruger kun nødvendige cookies for at få hjemmesiden til at fungere korrekt.',
							acceptNecessaryBtn: 'OK',
							showPreferencesBtn: 'Mere info',
						},
						preferencesModal: {
							title: 'Cookie-præferencer',
							acceptNecessaryBtn: 'Kun nødvendige',
							savePreferencesBtn: 'Gem præferencer',
							closeIconLabel: 'Luk',
							sections: [
								{
									title: 'Brug af cookies',
									description:
										'Vi bruger kun nødvendige cookies for at sikre grundlæggende funktionalitet på hjemmesiden.',
								},
								{
									title: 'Nødvendige cookies',
									description:
										'Disse cookies er nødvendige for, at hjemmesiden kan fungere korrekt. De kan ikke deaktiveres.',
									linkedCategory: 'necessary',
								},
							],
						},
					},
					en: {
						consentModal: {
							title: 'We use cookies',
							description:
								'We only use necessary cookies to make the website function properly.',
							acceptNecessaryBtn: 'OK',
							showPreferencesBtn: 'More info',
						},
						preferencesModal: {
							title: 'Cookie preferences',
							acceptNecessaryBtn: 'Necessary only',
							savePreferencesBtn: 'Save preferences',
							closeIconLabel: 'Close',
							sections: [
								{
									title: 'Use of cookies',
									description:
										'We only use necessary cookies to ensure basic functionality on the website.',
								},
								{
									title: 'Necessary cookies',
									description:
										'These cookies are required for the website to function properly. They cannot be disabled.',
									linkedCategory: 'necessary',
								},
							],
						},
					},
				},
			},
		});
	} catch (error: unknown) {
		// Prevent APP_INITIALIZER from blocking bootstrap if consent setup fails.
		if (environment.sentry.enabled) {
			sentry.captureException(error, {
				tags: {
					feature: 'cookie-consent',
					operation: 'init',
				},
			});
		}
	}
}

export async function setCookieConsentLanguage(lang: string): Promise<void> {
	if (!environment.enableCookieConsent) {
		return;
	}

	try {
		await CookieConsent.setLanguage(lang, true);
	} catch (error: unknown) {
		if (environment.sentry.enabled) {
			sentry.captureException(error, {
				level: 'warning',
				tags: {
					feature: 'cookie-consent',
					operation: 'set-language',
				},
			});
		}
	}
}
